import AuctionPortal from "../../apis/AuctionPortal";
import history from "../../history";
import {
  CREATE_EVENT_PARAMETER,
  EDIT_EVENT_PARAMETER,
  FETCH_EVENT_PARAMETER,
  USER_LOGOUT,
} from "../types";
import { encryptId,decryptIndex } from "../../components/Encryption";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isSessionExpired, userLogout } from "../login/loginActions";

toast.configure({
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: true,
});

export const fetchEventParameter = (auctionId) => async (dispatch) => {
  if (isSessionExpired()) {
    history.push("/SessionExpired");
  } else {
    try {
      document.getElementById("spinner").classList.add("spinnerDisplay");
      const response = await AuctionPortal.get(
        `/event/${auctionId}/eventparameter`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      dispatch({ type: FETCH_EVENT_PARAMETER, payload: response.data });
      document.getElementById("spinner").classList.remove("spinnerDisplay");
    } catch (error) {
      document.getElementById("spinner").classList.remove("spinnerDisplay");
      switch (error.response.status) {
        case 408:
          history.push("/MultipleLogin");
          dispatch({ type: USER_LOGOUT });
          break;
        case 401:
          history.push("/NotAuthorised");
          break;
        case 403:
          history.push("/acessforbidden");
          break;
        case 404:
          history.push("/PageNotFound");
          break;
        case 400:
          history.push("/BadRequest");
          break;
        default:
          toast.error("Error Occurred");
      }
    }
  }
};

export const editEventParameter =
  (auctionId, formValues) => async (dispatch) => {
    if (isSessionExpired()) {
      history.push("/SessionExpired");
    } else {
      try {
        document.getElementById("spinner").classList.add("spinnerDisplay");
        const response = await AuctionPortal.put(
          `/event/${auctionId}/eventparameter`,
          {
            ...formValues,
            activeFlag: "Y",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        dispatch({ type: EDIT_EVENT_PARAMETER, payload: response.data });

        document.getElementById("spinner").classList.remove("spinnerDisplay");
        history.goBack();
        toast("Edited Successfully");
      } catch (error) {
        document.getElementById("spinner").classList.remove("spinnerDisplay");
        switch (error.response.status) {
          case 408:
            history.push("/sessionExpired");
            dispatch({ type: USER_LOGOUT });
            break;
          case 401:
            history.push("/NotAuthorised");
            break;
          case 403:
            history.push("/acessforbidden");
            break;
          case 404:
            history.push("/PageNotFound");
            break;
          case 400:
            if (error.response.data.errors) {
              alert(JSON.stringify(error.response.data.errors));
            } else {
              toast.error(error.response.data.Description[0]);
            }
            break;
          default:
            toast.error("Error Occurred");
        }
      }
    }
  };

export const editEventLiveParameter =
  (auctionId, formValues) => async (dispatch) => {
    if (isSessionExpired()) {
      history.push("/SessionExpired");
    } else {
      try {
        document.getElementById("spinner").classList.add("spinnerDisplay");
        const response = await AuctionPortal.put(
          `/event/${auctionId}/eventparameter/live`,
          {
            ...formValues,
            activeFlag: "Y",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        dispatch({ type: EDIT_EVENT_PARAMETER, payload: response.data });

        document.getElementById("spinner").classList.remove("spinnerDisplay");
        history.goBack();
        toast("Edited Successfully");
      } catch (error) {
        document.getElementById("spinner").classList.remove("spinnerDisplay");
        switch (error.response.status) {
          case 408:
            history.push("/sessionExpired");
            dispatch({ type: USER_LOGOUT });
            break;
          case 401:
            history.push("/NotAuthorised");
            break;
          case 403:
            history.push("/acessforbidden");
            break;
          case 404:
            history.push("/PageNotFound");
            break;
          case 400:
            if (error.response.data.errors) {
              alert(JSON.stringify(error.response.data.errors));
            } else {
              toast.error(error.response.data.Description[0]);
            }
            break;
          default:
            toast.error("Error Occurred");
        }
      }
    }
  };

export const createEventParameter =
  (auctionId, formValues) => async (dispatch) => {
    if (isSessionExpired()) {
      history.push("/SessionExpired");
    } else {
      try {
        document.getElementById("spinner").classList.add("spinnerDisplay");
        const response = await AuctionPortal.post(
          `/event/${auctionId}/eventparameter`,
          formValues,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        dispatch({ type: CREATE_EVENT_PARAMETER, payload: response.data });
        document.getElementById("spinner").classList.remove("spinnerDisplay");
        history.goBack();
        toast("Added Successfully");
      } catch (error) {
        document.getElementById("spinner").classList.remove("spinnerDisplay");
        switch (error.response.status) {
          case 408:
            history.push("/sessionExpired");
            dispatch({ type: USER_LOGOUT });
            break;
          case 401:
            history.push("/NotAuthorised");
            break;
          case 403:
            history.push("/acessforbidden");
            break;
          case 404:
            history.push("/PageNotFound");
            break;
          case 400:
            if (error.response.data.errors) {
              alert(JSON.stringify(error.response.data.errors));
            } else {
              toast.error(error.response.data.Description[0]);
            }
            break;
          default:
            toast.error("Error Occurred");
        }
      }
    }
  };
